import { computed } from 'vue';

import { useStore } from 'vuex';
import { isUserWarehouseRestricted } from '@/helpers/permissions';

export default function useAuth() {
  const store = useStore();

  /** Read `Auth.me` through the store proxy so Vue tracks it as a dependency. */
  const meRef = computed(() => store.state.Auth.me);

  const user = computed(() => meRef.value);
  const userId = computed(() => user.value?.id);

  const isWarehouseRestricted = computed(() => isUserWarehouseRestricted(user.value));

  const hasPermission = predicate =>
    computed(() => Boolean(user.value) && Boolean(predicate(user.value)));

  const checkPermission = predicate => Boolean(user.value) && Boolean(predicate(user.value));

  return { meRef, user, userId, isWarehouseRestricted, hasPermission, checkPermission };
}
